import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LandingService {
  constructor(private http: HttpClient) {}

  landingPage = gql`
    query landingPage($landingSlug: String!, $fields: [String]!) {
      landingPage(landingSlug: $landingSlug, fields: $fields)
    }
  `;

  setONDCProduct(data: any): Observable<any> {
    return this.http.post(`${environment.bookingApiUrl}/ondc-search`, data);
  }
}
